module.exports = __webpack_public_path__ + "static/media/ddtalking.7ff2e54e.gif";